$(document).on('update ready show.bs.modal', function () {
  $('.alert-dismissible').delay(2500).fadeOut(750)
});

